 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		85: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/pentapod/" + ({"4":"addon-default-entry","5":"addon-entry-2d-color-picker","6":"addon-entry-better-img-uploads","7":"addon-entry-block-count","8":"addon-entry-block-palette-icons","9":"addon-entry-blocks2image","10":"addon-entry-cat-blocks","11":"addon-entry-clones","12":"addon-entry-columns","13":"addon-entry-copy-reporter","14":"addon-entry-custom-block-shape","15":"addon-entry-custom-block-text","16":"addon-entry-custom-menu-bar","17":"addon-entry-custom-zoom","18":"addon-entry-data-category-tweaks-v2","19":"addon-entry-debugger","20":"addon-entry-default-costume-editor-color","21":"addon-entry-disable-paste-offset","22":"addon-entry-disable-stage-drag-select","23":"addon-entry-editor-buttons-reverse-order","24":"addon-entry-editor-colored-context-menus","25":"addon-entry-editor-compact","26":"addon-entry-editor-extra-keys","27":"addon-entry-editor-number-arrow-keys","28":"addon-entry-editor-sounds","29":"addon-entry-editor-square-inputs","30":"addon-entry-editor-stage-left","31":"addon-entry-editor-stepping","32":"addon-entry-editor-theme3","33":"addon-entry-expanded-backpack","34":"addon-entry-fullscreen","35":"addon-entry-gamepad","36":"addon-entry-hide-delete-button","37":"addon-entry-hide-flyout","38":"addon-entry-hide-new-variables","39":"addon-entry-hide-stage","40":"addon-entry-initialise-sprite-position","41":"addon-entry-load-extensions","42":"addon-entry-mediarecorder","43":"addon-entry-mouse-pos","44":"addon-entry-move-to-top-layer","45":"addon-entry-no-script-bumping","46":"addon-entry-number-pad","47":"addon-entry-paint-by-default","48":"addon-entry-paint-snap","49":"addon-entry-remove-curved-stage-border","50":"addon-entry-remove-sprite-confirm","51":"addon-entry-script-snap","52":"addon-entry-search-sprites","53":"addon-entry-sprite-properties","54":"addon-entry-swap-local-global","55":"addon-entry-transparent-orphans","56":"addon-entry-tw-disable-cloud-variables","57":"addon-entry-tw-disable-compiler","58":"addon-entry-tw-disable-vibration","59":"addon-entry-tw-remove-backpack","60":"addon-entry-tw-remove-feedback","61":"addon-entry-tw-straighten-comments","62":"addon-entry-variable-manager","63":"addon-entry-vol-slider","64":"addon-entry-zebra-striping","65":"addon-l10n-de","66":"addon-l10n-es","67":"addon-l10n-fi","68":"addon-l10n-fr","69":"addon-l10n-hu","70":"addon-l10n-it","71":"addon-l10n-ja","72":"addon-l10n-ko","73":"addon-l10n-nl","74":"addon-l10n-pl","75":"addon-l10n-pt","76":"addon-l10n-ro","77":"addon-l10n-ru","78":"addon-l10n-sl","79":"addon-l10n-tr","80":"addon-l10n-zh-cn","81":"addon-l10n-zh-tw","83":"addons","88":"iframe-extension-worker","89":"library-backdrops","90":"library-costumes","91":"library-sounds","92":"library-sprites","94":"sb"}[chunkId]||chunkId) + "." + {"4":"c5b2db07ce66546a1780","5":"34f123a07f6102c4baf3","6":"f190b749e4002ed12d1a","7":"99edd4da701fcac4c65d","8":"3cf0bcc09c11eeb1e798","9":"29b14057772f36b038d1","10":"04095568dfa70aef355d","11":"22d628e5ffceea9e869e","12":"9ddd42fc5a01fa83913d","13":"d9fa4da805f7a5c00999","14":"60302e700e12f10681da","15":"efe5d0919405eed4b83a","16":"455b8bc959a4715502a6","17":"b2631cfd16598af1f8f8","18":"9fa295dedf3cd005cff9","19":"0089c6b27bf6894aa0a0","20":"4f94da0888cc530e721b","21":"bd2979326a3524962468","22":"c408ba77a9f381a5106c","23":"5af84470aec5873b4961","24":"9f62d65d6290ad031099","25":"8b11f4737b5cadf9a625","26":"cfeeb32bd3d1b298cac8","27":"0f353edd8ee9e612bd48","28":"4e90a89725124bfa37a9","29":"ab1b00dc4a7f95122ec0","30":"dd634b5a09cbb0e19a25","31":"5c9ce323ad845a6fbec7","32":"5553ff2d2de6e73f53d9","33":"d5ec36cf782533ddb25f","34":"2183c6ea63ee4e494cbd","35":"2757aa281ec7fad8f311","36":"aa28caa5df6cd4be6dd0","37":"bc917a28743185376474","38":"75ecdb85f6a1b6f8df70","39":"5cb99d770f5c095a893e","40":"be23c63de7e2725455d7","41":"9472dc4a5c72e6d0efaa","42":"d44f1f5ee7a66a8191d5","43":"a27f9f7b44b6e43524c1","44":"7d281e4325456e8316f9","45":"5ce63d92383c1cd94062","46":"8c7ff05b5867abe16353","47":"451227484fc8c9b8a2c9","48":"003513d5a4e8c0bae0af","49":"91ec0874f233ceb7f224","50":"ce099c2ada31d88074a7","51":"06cb63aab5ac05dc6f73","52":"725b25c22a5f44bfa3b3","53":"fd9455638e8d0a7488da","54":"236f10ba4a192cad5dac","55":"8c311c80fad308a30a1b","56":"7e5d3da8178d3e47d5cd","57":"669df1ecaad6ae12722b","58":"ab7ba02e808b0b1675ae","59":"c63ca4dc603fc31b33ec","60":"18425e323c3a9a7b4eec","61":"adeb3dd9fe5c8c23a572","62":"962bd4b02015500062e6","63":"b8115a83da45a6143123","64":"b24914a178ec792945da","65":"1ff7c621cb4bae53722e","66":"ea490e55d672d93e7dc4","67":"7cfd6460f614feff2eaa","68":"5768ba1b4c07dc90827b","69":"6ff990127f6d9feb6155","70":"e228adfbe2776379db78","71":"fa7e5df9189dc5dfaf18","72":"156da068d6076b5210b8","73":"c9a246d862264d7b6861","74":"ff67272418b6222fe2ed","75":"b3a598b43b3b8581587c","76":"e442569ca379d286d32d","77":"04941c2df18b58afcb41","78":"c08b59b58a692376b2c9","79":"4c459d68daea296cebe8","80":"40469b723c5706d8c7be","81":"79130f6d3391d30a8b1c","83":"9f8479f5d5e96b1ae0ee","88":"3228feebbb35a7c1ca0c","89":"434eb50a63485e1c1a17","90":"55ef5b62e627161ad650","91":"4e25502adbc1306a57bf","92":"857ad4e5f38fec07ce2b","94":"d4c546c5e59a3d9a84f2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpGUI"] = window["webpackJsonpGUI"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([908,0,3,1,2]);
 	// run deferred modules when ready
 	return checkDeferredModules();
